import { InputFieldDef } from '../../../types/admin';

export function rewriteOrder(fields: InputFieldDef[]): InputFieldDef[] {
  return fields.map((field, index) => ({ ...field, order: index * 10 }));
}

export function orderFields(fields: InputFieldDef[]): InputFieldDef[] {
  return [...fields].sort((left, right) => (left.order ?? 0) - (right.order ?? 0));
}
